<template>
  <div v-if="detail" class="rank">
    <div class="title" :style="detail.bgstyle">投票排名</div>
    <div class="info">
      <div class="num">
        已参与
        <div class="number">{{ total }}</div>
        人
      </div>
      <!-- <div @click="show = true" class="rule">
        活动规则
        <van-icon style="margin-left:.12rem" name="arrow" />
      </div> -->
    </div>

    <div class="search-area">
      <van-field v-model="keywords" placeholder="通过选手姓名，手机号搜索">
        <template #button>
          <van-button size="small" type="info" icon="search" @click="search" :color="detail.bgstyle.background"></van-button>
        </template>
      </van-field>
    </div>
    <div class="list-area">
      <van-tabs v-model="active" :color="detail.bgstyle.background">
        <van-tab title="全部选手"></van-tab>
        <van-tab title="投票排行"></van-tab>
      </van-tabs>
      <List v-if="rankList.length > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getRankList">
        <Row :gutter="16" class="list">
          <Col v-for="(item, index) in rankList" :key="index" span="12">
            <div
              @click="
                goDetail({
                  name: 'sportsResultVote',
                  params: $route.params,
                  query: { id: item.id },
                })
              "
              class="item"
            >
              <div class="cover">
                <div v-if="+media_type===3" class="text">{{item.mediaurl||''}}</div>
                <img v-else :src="item.mediaurl | videoposter" />
                <van-tag class="tag" mark type="primary" :color="detail.bgstyle.background">拉票 </van-tag>
              </div>
              <div class="info">
                <div class="name">{{ item.name || item.nickname }}</div>
                <van-button
                  class="btn"
                  :plain="!item.isvote"
                  :disabled="item.isvote"
                  size="small"
                  :color="detail.bgstyle.background"
                  @click.stop="vote(item)"
                >
                  <div class="btn-area">
                    <div>
                      <span v-if="item.isvote">已投</span>
                      <van-icon v-else name="like" />
                    </div>
                    <span style="margin-left:.5rem">|</span>
                    <div style="margin-left:.5rem">{{ item.score * 1 }}</div>
                  </div>
                </van-button>
              </div>
            </div>
          </Col>
        </Row>
      </List>
      <Empty v-else description="暂无数据" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.rank {
  background: #fff;
  padding-top: 0.2rem;

  .vhtml {
    padding-top: 1.2rem;

    /deep/ img {
      max-width: 100%;
    }
  }

  .title {
    margin: 0 auto;
    width: 1.6rem;
    height: 0.35rem;
    background: #1a9dfe;
    font-size: 0.36rem;
    padding: 0.1rem 0.45rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0.12rem 0 0.12rem;
  }

  .info {
    font-size: 0.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.14rem 0;

    > div {
      padding: 0rem 0.3rem;
    }

    .num {
      color: #333;
      display: flex;
      border-right: 1px solid #eee;

      .number {
        color: #1a9dfe;
        padding: 0 0.04rem;
        font-family: sans-serif;
        font-weight: bold;
      }
    }

    .rule {
      color: #999;
      display: flex;
      align-items: center;
    }
  }

  .search-area {
    .van-cell.van-field {
      /deep/ .van-field__body {
        background: #f6f6f6;
        padding: 0 0 0 0.08rem;
      }
    }
  }

  .list {
    padding: 0.3rem 0.15rem;
    background: #f6f6f6;

    .item {
      background: #fff;
      margin-bottom: 0.32rem;
      display: inline-block;
      width: 100%;

      .cover {
        width: 100%;
        height: 2.4rem;
        position: relative;

        .tag {
          position: absolute;
          top: 0.12rem;
          left: 0;
        }

        .text{
          width: 100%;
          height: 2.4rem;
          font-size: .24rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .name {
        font-size: 0.28rem;
        padding: 0.1rem 0;
        height: .3rem;
      }

      .info {
        padding: 0 0.2rem 0.2rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .btn {
          width: 100%;

          .btn-area {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
          }
        }
      }
    }
  }
}
</style>

<script>
import { Tabs, Tab, Button, Field, Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Tag } from 'vant'

export default {
  computed: {
    buttonColor() {
      let detail = this.detail
      if (!detail) return '#ccc'
      return `${detail.tabstyle[0]['color']}`
    },
  },
  watch: {
    active(val) {
      this.rankList = []
      this.page = 1
      this.finished = false
      this.$nextTick(() => {
        this.getRankList()
      })
    },
  },
  components: {
    vanField: Field,
    vanButton: Button,
    vanTab: Tab,
    vanTabs: Tabs,
    vanTag: Tag,
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
  },
  props: ['item_sub_id', 'sports_id','item_id'],
  data() {
    return {
      content: '',
      show: false,
      keywords: '',
      rankList: [],
      loading: false,
      finished: false,
      detail: '',
      page: 1,
      total: 0,
      systime: '',
      myinfo: '',
      active: 0,
      media_type: 1
    }
  },
  methods: {
    goDetail(query) {
      this.$router.push(query)
    },
    vote(row) {
      // if (row.isvote) {
      //   return
      // }
      this.$api.sports
        .vote({
          mcloud_sports_item_user_id: row.id,
        })
        .then((r) => {
          this.search();
        })
    },
    search() {
      this.page = 1;
      this.rankList = []
      this.getRankList()
    },
    getRankList: function() {
      let sort = 1
      if (this.active == 1) {
        sort = 2
      }
      let query = Object.assign(
        {},
        {
          cpgid: this.item_sub_id,
          page: this.page,
          keywords: this.keywords,
          sort: sort,
        }
      )

      this.$api.sports.compareRank(query).then((res) => {
        this.systime = res.sys_time
        this.loading = false
        let { list, page, pages, myinfo, total, content, rules, media_type } = res.data
        this.content = rules
        this.myinfo = myinfo
        this.total = total
        this.media_type = media_type
        list.forEach((item, index) => {
          if (index > 0 && +item.score === +list[index - 1]['score']) {
            item.rank = list[index - 1]['rank']
          } else if (index === 0) {
            if (this.rankList.length) {
              let last = this.rankList[this.rankList.length - 1]
              if (+item.score === +last.score) {
                item.rank = last.rank
              } else {
                item.rank = last['rank'] * 1 + 1
              }
            } else {
              item.rank = 1
            }
          } else {
            item.rank = list[index - 1]['rank'] * 1 + 1
          }
          item.isvote = false
          // if (item.urid == myinfo.myvote) {

           for(var i in myinfo.myvote){
             if(myinfo.myvote[i] == item.urid){
                 item.isvote = true
                 return
             }
           }

        })
        this.rankList = this.rankList.concat(list)
        if (page >= pages) this.finished = true
        else this.page++
      })
    },
    init: function() {
      this.$toast.loading({
        duration: 0,
      })
      let params = { cpgid: this.item_sub_id }
      this.$api.sports.sportsMain(this.sports_id).then((res) => {
        let { bgstyle, id, tabstyle, introstyle, title } = res.data
        try {
          bgstyle = JSON.parse(bgstyle)
          tabstyle = JSON.parse(tabstyle)
          introstyle = JSON.parse(introstyle)
        } catch (e) {
          console.error(e)
        }
        this.detail = { id, bgstyle, tabstyle, introstyle, title }
        this.$toast.clear()
      })
    },
  },
  mounted() {
    this.init()
    this.getRankList()
  },
}
</script>
